import { VueQueryPlugin } from '@tanstack/vue-query';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';

import routes from '~pages';

// Import CAAS UI components and styles
import { injectTheme } from '@caas-xyz/ui';
import './style.css';

import App from './App.vue';

const app = createApp(App);
injectTheme();

// Setup Pinia
const pinia = createPinia();
app.use(pinia);

// Setup Vue Router
const router = createRouter({
  history: createWebHistory(),
  routes,
});
app.use(router);

// Setup Vue Query
app.use(VueQueryPlugin);

// Mount app
app.mount('#app');
